import { browserHistory } from 'react-router';

// Quem manda na troca de senha obrigatoria e' o SERVIDOR.
//
// Ele responde 403 com o codigo "40106 must_change_password" em qualquer rota
// enquanto a pessoa nao cadastrar a senha dela (ver server/comum/Authorization.php).
// Este interceptador escuta esse 403 em todas as chamadas da aplicacao e leva a
// pessoa pra tela de perfil — inclusive quando a situacao muda no meio da sessao,
// como quando um administrador redefine a senha de alguem que ja' esta' logado.
//
// A marca no localStorage e' so' atalho de tela: ela nao libera nada sozinha,
// porque o servidor recusa de novo na chamada seguinte.

let instalado = false;

export default function interceptaTrocaSenha() {
  if (instalado || typeof window.fetch !== 'function') {
    return;
  }
  instalado = true;

  const fetchOriginal = window.fetch.bind(window);

  window.fetch = function (...argumentos) {
    return fetchOriginal(...argumentos).then((resposta) => {
      if (!resposta || resposta.status !== 403) {
        return resposta;
      }

      // clone() porque o corpo so' pode ser lido uma vez — quem chamou
      // precisa receber a resposta intacta.
      resposta
        .clone()
        .json()
        .then((corpo) => {
          const valor = corpo && corpo.status && corpo.status.value;
          if (typeof valor !== 'string' || valor.indexOf('40106') !== 0) {
            return;
          }

          localStorage.setItem('trocarSenha', '1');
          const telaPerfil = `${process.env.PUBLIC_URL}/perfil`;
          if (window.location.pathname !== telaPerfil) {
            browserHistory.push(telaPerfil);
          }
        })
        .catch(() => {
          // 403 sem corpo JSON nao e' deste caso; segue o jogo.
        });

      return resposta;
    });
  };
}
